module.exports = {"350124100":"梅城镇","350124101":"梅溪镇","350124102":"白樟镇","350124103":"金沙镇","350124104":"白中镇","350124105":"池园镇","350124106":"坂东镇","350124107":"塔庄镇","350124108":"省璜镇","350124109":"雄江镇","350124110":"东桥镇","350124200":"云龙乡","350124201":"上莲乡","350124204":"三溪乡","350124205":"桔林乡","350124206":"下祝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350124.json
// module id = 1278
// module chunks = 0